'use client';

import { useId } from 'react';
import { siteBrandName } from '@/platform/legal/siteLegal';
import { TermsAcceptanceForm } from '@/platform/legal/TermsAcceptanceForm';

/**
 * Blocking terms gate modal. Not dismissible — user must accept to continue.
 * Legal doc links open in a new tab.
 */
export function TermsAcceptModal() {
  const brand = siteBrandName();
  const titleId = useId();

  return (
    <div
      className="terms-accept-modal terms-accept-modal--open"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
    >
      <div className="terms-accept-modal__card">
        <h2 id={titleId}>Accept Terms of Use</h2>
        <p>
          Before you use {brand}, please review and accept our Terms of Use, Community Guidelines,
          and Privacy Policy.
        </p>
        <TermsAcceptanceForm onAccepted={() => undefined} />
      </div>
    </div>
  );
}
